import { Outlet } from 'react-router'

export default function UnauthenticatedLayout() {
  return (
    <main className="flex gap-x-10 h-screen w-screen p-4 lg:p-10">
      <section className="hidden lg:block lg:w-2/3 bg-base-300 rounded-lg" />

      <section className="w-full lg:max-w-1/3">
        <Outlet />
      </section>
    </main>
  )
}
